// extracted by mini-css-extract-plugin
export var XL = "styles-module--XL--6Vn2G";
export var Large = "styles-module--Large--1B0ic";
export var Medium = "styles-module--Medium--1C109";
export var Small = "styles-module--Small--b5EZE";
export var S = "styles-module--S--3sQAd";
export var iconColor = "styles-module--iconColor--JRUrQ";